export default class ProductDataError {
    constructor(args) {
        this.exceptionString = args.exceptionString
        this.inFileValue = args.inFileValue
        this.fixitColumnName = args.fixitColumnName
    }
}
